<template>
    <div>
        <b-button block variant="outline-primary" @click="bulk">
            Have a huge list of business to add? Try bulk upload
            </b-button>
        <br>
        <br>
        <b-form :validated="form_validated">
            <div>
                <label for="business-name">Business Name</label>
                <b-form-input 
                    id="business-name" 
                    placeholder="Juan Pizzeria" 
                    v-model="name"
                    :state="validation_name"
                ></b-form-input>
            </div>

            <br>
            
            <div>
                <label for="city">Street Address</label>
                <b-form-input 
                    id="street" 
                    placeholder="752 Ayala Avenue" 
                    v-model="street"
                    :state="validation_street"
                ></b-form-input>
            </div>

            <br>

            <div>
                <label for="city">City</label>
                <b-form-input 
                    id="city" 
                    placeholder="Makati City" 
                    v-model="city"
                    :state="validation_city"
                ></b-form-input>
            </div>

            <br>

            <div>
                <label for="category">Categories</label>
                <tags-input element-id="tags"
                    v-model="selectedTags"
                    :existing-tags="[
                        { key: 'chinese', value: 'Chinese' },
                        { key: 'japanese', value: 'Japanese' },
                        { key: 'filipino', value: 'Filipino' },
                    ]"
                    :typeahead="true"
                    placeholder="Korean, Filipino, etc"
                    @blur="onBlur"
                    @tags-updated="onTagsUpdated"
                >
                </tags-input>
                <b-form-invalid-feedback :state="tagsValid">
                    Your categories must be at least one.
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="tagsValid">
                    Looks Good.
                </b-form-valid-feedback>
            </div>
            

            <br>

            <div>
                <label for="phone">Business Phone</label>
                <b-form-input 
                    id="phone" 
                    placeholder="2 7626642" 
                    v-model="phone"
                    :state="validation_phone"
                ></b-form-input>
            </div>

            <br>
            
            <div>
                <label for="web">Web Address</label>
                <b-form-input 
                    id="web" 
                    placeholder="https://www.juanpizerria.com" 
                    v-model="web"
                    :state="validation_web"
                ></b-form-input>
            </div>

            <br>
            
            <div>
                <label for="email">Email Address</label>
                <b-form-input 
                    id="email" 
                    placeholder="name@yourbusiness.com" 
                    v-model="email"
                    :state="validation_email"
                ></b-form-input>
            </div>

        </b-form>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    name: 'BusinessDetails',
    components: {

    },
    data() {
        return {
            name: null,
            street: null,
            city: null,
            category: null,
            phone: null,
            web: null,
            email: null,
            selectedTags: [
                //{ key: 'web-development', value: 'Web Development' },
                //{ key: 'php', value: 'PHP' },
                //{ key: 'javascript', value: 'JavaScript' },
            ],
            tagsValid: null
        }
    },
    computed: {
        validation_name() {
            if (this.name == null) {
                return null
            }
            return this.name.length > 0
        },
        validation_street() {
            if (this.street == null) {
                return null
            }
            return this.street.length > 0
        },
        validation_city() {
            if (this.city == null) {
                return null
            }
            return this.city.length > 0
        },
        validation_phone() {
            if (this.phone == null) {
                return null
            }
            return this.phone.length > 0
        },
        validation_web() {
            if (this.web == null) {
                return null
            }
            return this.web.length > 0
        },
        validation_email() {
            if (this.email == null) {
                return null
            }
            return this.email.length > 0
        },
        // if true, will put a checkmark in all form input
        // if false, will put a wrong / red if the form input has been touched already
        form_validated() {
            if (this.validation_name == true &&
                this.validation_street == true &&
                this.validation_city == true &&
                this.tagsValid == true && 
                this.validation_phone == true
                //this.validation_web == true &&
                //this.validation_email == true
            ) {
                return true
            }
            return false
        }
    },
    methods: {
        check2: function() {
            // check tags 
            if (this.selectedTags == 0) {
                this.tagsValid = false
            }

            if (this.form_validated == false) {
                // if form_validated is false
                // try to set fields that are null / not touched by the user to empty string
                // so that the validation status will kickin...
                if (this.validation_name == null) {
                    this.name = ''
                }
                if (this.validation_street == null) {
                    this.street = ''
                }
                if (this.validation_city == null) {
                    this.city = ''
                }
                if (this.validation_category == null) {
                    this.category = ''
                }
                if (this.validation_phone == null) {
                    this.phone = ''
                }
                /*
                if (this.validation_web == null) {
                    this.web = ''
                }
                if (this.validation_email == null) {
                    this.email = ''
                }
                */
                return false
            } else {
                return true
            }
        },
        onBlur() {
            console.log('onBlur')
            if (this.selectedTags.length == 0) {
                this.tagsValid = false
            } else {
                this.tagsValid = true
            }
        },
        onTagsUpdated() {
            if (this.selectedTags.length == 0) {
                this.tagsValid = false
            } else {
                this.tagsValid = true
            }
        },
        bulk() {
            console.log('bulk clicked')
            this.$root.$emit('showFutureFeature')
        }
    },
    mounted() {

    }
}
</script>